export const MESSAGING_BANK_ASSET = 'Messaging bank asset';

export const FILTER_TYPE = {
  tags: 'resourcesTag',
  types: 'resourcesType',
};
